import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
export const ContainerCalendar = styled('div')`
  margin-top: 20px;
  @media (max-width: 768px) {
    .fc-toolbar.fc-header-toolbar {
      display: flex;
      flex-direction: column;
    }
  }
`;


export const BoxContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  max-width: 400px;
  width: 100%;
  border-radius: 5px;
  box-shadow: 24;
  padding: 1rem;
  &:focus {
    outline: none;
  }
`;

export const SelectColors = styled('div')`
  display: grid;
  grid-template-columns: repeat(5, 40px);
  justify-content: center;
  place-items: center;
  padding-top: 10px;
`;

export const BackgroundColorRounded = styled('div') `
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  input[type='radio'] {
    position: relative;
    width: 20px;
    height: 20px;
    outline: none;
    -webkit-appearance: none;
    border-radius: 50%;
    cursor: pointer;
    margin: 0px;
  }
  input:checked[type='radio'] {
    outline: 1px solid #000;
    cursor: pointer;
  }
`;

export const PreContainer = styled('div')`
  position: relative;
`;

export const CopyButton = styled('button')`
  position: absolute;
  top: 0;
  right: 0;
  background-color: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.2);
  }
`;

export const Pre = styled('pre')`
  background-color: #f6f8fa;
  border-radius: 4px;
  padding: 20px;
  font-size: 14px;
  line-height: 1.5;
`;
